const { defaultSlickResponsive } = require("./slick-params")

var block_keyNumbers = {
    ui: {},

    init: function () {
        this.bindUI()
        this.bindEvents()

        this.initSlider()
    },

    bindUI: function () {
        this.ui.$slider = $('.js-keynumber-slider')
    },

    bindEvents: function () {
        // this.ui.$slick.on('ready', this.mediaToCarousel.bind(this));
    },

    initSlider: function () {
        this.ui.$slider.slick({
            ...defaultSlickResponsive,
            // slidesToShow:3,
            infinite: true,
            // variableWidth: true,
            dots: true,
            swipeToSlide: true,
            // centerMode: true,
            arrows: false,
            rows: 0
        })
    },
}

module.exports = block_keyNumbers
